import {
	Directive,
	ElementRef,
	EventEmitter,
	Input,
	NgZone,
	OnDestroy,
	OnInit,
	Output,
	Renderer2
} from "@angular/core";

@Directive({
	selector: "[appClickOutside]",
	standalone: false
})
export class ClickOutsideDirective implements OnInit, OnDestroy {
	@Output() clickOutside = new EventEmitter<void>();
	/** When it's true, the event is attached to the container itself,
	 * and just the click on an anchor triggert the emit */
	@Input() detectAnchorOnly = false;
	private unlistener: (() => void) | null = null;

	constructor(
		private elementRef: ElementRef,
		private renderer: Renderer2,
		private ngZone: NgZone
	) { }

	ngOnInit() {
		this.ngZone.runOutsideAngular(() => {
			// console.info("clickoutside: init");
			this.unlistener = this.renderer.listen(this.detectAnchorOnly ? this.elementRef.nativeElement : "document", "click",
				(event: MouseEvent) => {
					// console.info("clickoutside: cliccato");
					if (
						event.button === 0 && // left click and
						(
							!(this.detectAnchorOnly || this.elementRef.nativeElement.contains(event.target)) ||
							(event.target as HTMLElement).closest("a") /* clicked on link */
						)
					) {
						this.ngZone.run(() => {
							// console.info("clickoutside: emit");
							this.clickOutside.emit();		
						});
					}
				});
		});
	}

	ngOnDestroy() {
		// console.info("clickoutside: destroy");
		if (this.unlistener) {
			// console.info("clickoutside: destroy, rimosso evento");
			this.unlistener();
			this.unlistener = null;
		}
	}
}